/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { DeviceLabelUpdate, UserCredential, UserCredentialWrapper } from '@administration-client/user-shared';
import { Component, computed, input, InputSignal, output, OutputEmitterRef, Signal } from '@angular/core';
import { ConvertForDataTestPipe, createEmptyStateResource, StateResource } from '@common/tech-shared';
import { SpinnerComponent } from '@odc/component';
import {
  BadgeConfig,
  CardColComponent,
  CardColRightComponent,
  CardComponent,
  CardItemComponent,
  OverviewListPageComponent,
} from '@ods/system';
import { DeviceActionsComponent } from '../device-actions/device-actions.component';
import { TwoFactorUtil } from '../two-factor.util';

@Component({
  selector: 'administration-two-factor',
  imports: [
    CardColComponent,
    CardColRightComponent,
    CardComponent,
    CardItemComponent,
    ConvertForDataTestPipe,
    DeviceActionsComponent,
    OverviewListPageComponent,
    SpinnerComponent,
  ],
  templateUrl: './two-factor.component.html',
})
export class TwoFactorComponent {
  public readonly twoFactorDevicesStateResource: InputSignal<StateResource<UserCredentialWrapper>> =
    input.required<StateResource<UserCredentialWrapper>>();
  public readonly renameStateResource: InputSignal<StateResource<string>> =
    input<StateResource<string>>(createEmptyStateResource<string>());
  public readonly deleteStateResource: InputSignal<StateResource<string>> =
    input<StateResource<string>>(createEmptyStateResource<string>());

  public readonly addDevice: OutputEmitterRef<void> = output<void>();
  public readonly renameDevice: OutputEmitterRef<DeviceLabelUpdate> = output<DeviceLabelUpdate>();
  public readonly deleteDevice: OutputEmitterRef<string> = output<string>();

  public readonly devices: Signal<UserCredential[]> = computed(() =>
    TwoFactorUtil.getCredentials(this.twoFactorDevicesStateResource()?.resource),
  );

  public readonly badgeConfig: Signal<BadgeConfig> = computed(() => TwoFactorUtil.getBadgeConfig(this.devices()));

  public getDeviceName(device: UserCredential): string {
    return TwoFactorUtil.getDeviceName(device);
  }
}
